(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-conversion"]) return;
  try {
    
  const initializeConversionCart = () => {
    const section = document.querySelector('[data-pw-cart-section]');
    const form = document.getElementById('PwCartForm');
    const updateButton = form?.querySelector('[data-pw-update]');
    let submitTimer;

    if (!section || !form || !updateButton || section.dataset.pwCartReady === 'true') return;
    section.dataset.pwCartReady = 'true';

    const submitUpdate = () => {
      section.dataset.updating = 'true';
      form.requestSubmit(updateButton);
    };

    const queueUpdate = () => {
      window.clearTimeout(submitTimer);
      submitTimer = window.setTimeout(submitUpdate, 350);
    };

    const notifyCartSurfaces = (cartState) => {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'conversion-cart',
          cartData: cartState
        });
      }

      document.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          source: 'conversion-cart',
          cart: cartState
        }
      }));

      if (typeof window.SLIDECART_UPDATE === 'function') {
        try {
          window.SLIDECART_UPDATE();
        } catch (slideCartError) {
          console.error(slideCartError);
        }
      }
    };

    const updatePurchaseOption = async (fieldset) => {
      const selectedType = fieldset.querySelector('[data-pw-purchase-type]:checked');
      const planSelect = fieldset.querySelector('[data-pw-plan-select]');
      const frequency = fieldset.querySelector('[data-pw-frequency]');
      const status = fieldset.querySelector('[data-pw-purchase-status]');
      const controls = fieldset.querySelectorAll('input, select');
      const isAutoship = selectedType?.value === 'autoship';
      const sellingPlan = isAutoship ? Number(planSelect?.value) : null;
      const sectionId = section.dataset.sectionId;
      const lineNumber = Number(fieldset.dataset.line);
      const quantity = Number(fieldset.dataset.quantity);
      const selectedValue = selectedType?.value;
      const cartNoteValue = document.getElementById('PwCartNote')?.value;
      const sectionsUrl = `${window.location.pathname}${window.location.search}`;
      let changePersisted = false;

      if (!selectedType || (isAutoship && !sellingPlan) || !sectionId) return;

      frequency.hidden = !isAutoship;
      status.hidden = true;
      controls.forEach((control) => { control.disabled = true; });
      section.dataset.updating = 'true';

      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            line: lineNumber,
            quantity,
            selling_plan: sellingPlan,
            sections: [sectionId, 'cart-icon-bubble'],
            sections_url: sectionsUrl
          })
        });

        if (!response.ok) throw new Error('Cart update failed');
        changePersisted = true;
        const cartState = await response.json();
        let cartSectionHtml = cartState.sections?.[sectionId];

        if (!cartSectionHtml) {
          const sectionUrl = new URL(window.location.href);
          sectionUrl.searchParams.set('section_id', sectionId);
          const sectionResponse = await fetch(sectionUrl.toString(), {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!sectionResponse.ok) throw new Error('Cart section render failed');
          cartSectionHtml = await sectionResponse.text();
        }

        const cartDocument = new DOMParser().parseFromString(cartSectionHtml, 'text/html');
        const nextSection = cartDocument.querySelector('[data-pw-cart-section]');
        if (!nextSection) throw new Error('Updated cart section was not found');

        const bubbleHtml = cartState.sections?.['cart-icon-bubble'];
        const bubbleTarget = document.getElementById('cart-icon-bubble');
        if (bubbleHtml && bubbleTarget) {
          const bubbleDocument = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const bubbleSource =
            bubbleDocument.querySelector('#shopify-section-cart-icon-bubble') ||
            bubbleDocument.querySelector('.shopify-section');
          if (bubbleSource) bubbleTarget.innerHTML = bubbleSource.innerHTML;
        }

        section.replaceWith(nextSection);
        initializeConversionCart();

        if (typeof cartNoteValue === 'string') {
          const refreshedNote = document.getElementById('PwCartNote');
          if (refreshedNote) refreshedNote.value = cartNoteValue;
        }

        const refreshedFieldset = document.querySelector(
          `[data-pw-purchase-options][data-line="${lineNumber}"]`
        );
        refreshedFieldset
          ?.querySelector(`[data-pw-purchase-type][value="${selectedValue}"]`)
          ?.focus({ preventScroll: true });

        notifyCartSurfaces(cartState);
      } catch (error) {
        if (changePersisted) {
          const previousPlan =
            fieldset.dataset.currentPurchase === 'autoship'
              ? Number(fieldset.dataset.currentPlan)
              : null;
          try {
            await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                line: lineNumber,
                quantity,
                selling_plan: previousPlan
              })
            });
          } catch (rollbackError) {
            console.error(rollbackError);
          }
        }

        const previousType = fieldset.querySelector(
          `[data-pw-purchase-type][value="${fieldset.dataset.currentPurchase}"]`
        );
        if (previousType) previousType.checked = true;
        if (fieldset.dataset.currentPlan && planSelect) planSelect.value = fieldset.dataset.currentPlan;
        frequency.hidden = fieldset.dataset.currentPurchase !== 'autoship';
        status.textContent = fieldset.dataset.errorMessage;
        status.hidden = false;
        controls.forEach((control) => { control.disabled = false; });
        delete section.dataset.updating;
        console.error(error);
      }
    };

    section.addEventListener('click', (event) => {
      const decrease = event.target.closest('[data-pw-decrease]');
      const increase = event.target.closest('[data-pw-increase]');
      const control = decrease || increase;

      if (!control) return;

      const line = control.closest('[data-pw-line]');
      const input = line?.querySelector('[data-pw-quantity]');

      if (!input) return;

      const step = Number(input.step) || 1;
      const minimum = Number(input.min) || 0;
      const maximum = input.max ? Number(input.max) : Number.POSITIVE_INFINITY;
      const current = Number(input.value) || minimum;
      const next = decrease ? current - step : current + step;

      input.value = String(Math.min(maximum, Math.max(minimum, next)));
      queueUpdate();
    });

    section.addEventListener('change', (event) => {
      if (event.target.matches('[data-pw-quantity]')) {
        queueUpdate();
        return;
      }

      if (event.target.matches('[data-pw-purchase-type], [data-pw-plan-select]')) {
        const fieldset = event.target.closest('[data-pw-purchase-options]');
        const autoshipSelected = fieldset?.querySelector('[data-pw-purchase-type][value="autoship"]')?.checked;

        if (event.target.matches('[data-pw-plan-select]') && !autoshipSelected) return;
        if (fieldset) updatePurchaseOption(fieldset);
      }
    });

    form.addEventListener('submit', () => {
      section.dataset.updating = 'true';
    });

  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeConversionCart, { once: true });
  } else {
    initializeConversionCart();
  }

  document.addEventListener('shopify:section:load', initializeConversionCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-conversion-layer"]) return;
  try {
    
  (() => {
    const placePurchaseHeading = () => {
      const heading = document.querySelector('[data-pw-purchase-heading]');
      const rechargeWidget = document.querySelector('.recharge-subscription-widget');

      if (!heading || !rechargeWidget || heading.dataset.placed === 'true') return;
      rechargeWidget.before(heading);
      heading.hidden = false;
      heading.dataset.placed = 'true';
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placePurchaseHeading, { once: true });
    } else {
      placePurchaseHeading();
    }

    document.addEventListener('shopify:section:load', placePurchaseHeading);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["petsworld-landing"] && !Shopify.designMode) return;
  try {
    
   document.querySelectorAll('[data-pw-section]').forEach((root) => {
      const packs = root.querySelectorAll('[data-pack]');
      const quantity = root.querySelector('[data-pw-quantity]');
      const cartButton = root.querySelector('[data-pw-cart-button]');

      packs.forEach((button) => button.addEventListener('click', () => {
         packs.forEach((item) => item.classList.remove('is-selected'));
         button.classList.add('is-selected');
         
         if (quantity) quantity.value = button.dataset.pack;
         if (cartButton) cartButton.textContent = `SHOP ${button.dataset.pack} ${button.dataset.pack === '1' ? 'PACK' : 'PACKS'} — CLAIM 15% OFF`;


         // Update CTA href
         const ctaButton = document.querySelector('#pw-packages a.pw-button');
         if (ctaButton && button.dataset.url) {
            ctaButton.href = button.dataset.url;
         }

      }));

      const demo = root.querySelector('.pw-demo');
      const scenarios = {
         healthy: ['#f2d34f', 'NORMAL RANGE (pH 6.5-7.0)', 'Health urine pH levels', 'Within the typical range. Continue monitoring over time.'],
         uti: ['#38b98a', 'ALKALINE RANGE (pH above 7.0)', 'High urine pH levels', 'May indicate a change worth discussing with your veterinarian if it persists.'],
         concern: ['#ef625d', 'ACIDIC RANGE (pH below 6.5)', 'Low urine pH levels', 'May indicate a change worth discussing with your veterinarian if it persists.']
      };

      root.querySelectorAll('[data-scenario]').forEach((button) => button.addEventListener('click', () => {
         const item = scenarios[button.dataset.scenario];
         root.querySelectorAll('[data-scenario]').forEach((tab) => tab.classList.remove('is-active'));
         button.classList.add('is-active');
         demo.style.setProperty('--result', item[0]);
         root.querySelector('[data-pw-result-label]').textContent = item[1];
         root.querySelector('[data-pw-result-title]').textContent = item[2];
         root.querySelector('[data-pw-result-copy]').textContent = item[3];
      }));
   });

  } catch(e) { console.error(e); }
})();
})();
